"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var InputBase_1 = __importDefault(require("atomicComponents/atoms/Forms/InputBase"));
var validators_1 = require("utils/form/validators");
var Select = function (_a) {
    var _b = _a.input, name = _b.name, value = _b.value, onChange = _b.onChange, placeholder = _b.placeholder, restInput = __rest(_b, ["name", "value", "onChange", "placeholder"]), meta = _a.meta, options = _a.options, label = _a.label, rest = __rest(_a, ["input", "meta", "options", "label"]);
    var errorToShow = (0, validators_1.getErrorToShow)(meta);
    return ((0, jsx_runtime_1.jsxs)(FormControl_1.default, __assign({ fullWidth: true, error: errorToShow }, { children: [(0, jsx_runtime_1.jsx)(Select_1.default, __assign({ variant: "outlined", color: "primary", autoWidth: true, displayEmpty: true }, rest, { inputProps: restInput, input: (0, jsx_runtime_1.jsx)(InputBase_1.default, {}), name: name, value: value, onChange: function (event) { return onChange(event.target.value); }, error: errorToShow, renderValue: function (selected) {
                    var _a;
                    var selectedOption = options.find(function (option) { return option.value === selected; });
                    return (_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _a !== void 0 ? _a : (label || 'Select an option');
                } }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ value: option.value }, { children: option.label }), option.value)); }) })), errorToShow && (0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: errorToShow })] })));
};
exports.default = Select;
